import axios from 'axios'
import { backUrl, fakeUser } from '@src/config.js'
import { useIndexStore } from '@src/store'
import { router, loginRoute } from '@src/router'
import { createGettext } from '@src/utils/i18n'

function getGettextFunc() {
  return createGettext().$gettext
}

export async function checkAuth () {
  if (fakeUser) {
    return Promise.resolve({ fullName: 'Mock user' })
  } else {
    return new Promise((resolve, reject) => {
      const rawToken = localStorage.getItem('user-token')
      if (!rawToken) {
        reject()
      }
      const token = rawToken.split(' ').pop()
      return axios({ url: `${backUrl}token/verify`, data: { token }, method: 'POST' })
        .then(_response => {
          let user = {}
          try {
            const tokenUser = JSON.parse(atob(token.split('.')[1]))
            user = {
              id: tokenUser.id,
              user_name: tokenUser.user_name,
              user_profile: tokenUser.user_profile,
            }
          } catch (error) {
            console.error(error)
            user = { fullName: 'Unkown, please log in again' }
          }
          resolve(user)
        })
    }).catch(() => {
      return null
    })
  }
}

export function login (username, password) {
  if (fakeUser) {
    return Promise.resolve()
  }
  return new Promise((resolve, reject) => {
    const store = useIndexStore()
    const $gettext = getGettextFunc()
    axios({ url: `${backUrl}token`, data: { username, password }, method: 'POST' })
      .then(response => {
        localStorage.setItem('user-refresh', response.data.refresh)
        const rawToken = `JWT ${response.data.access}`
        localStorage.setItem('user-token', rawToken)
        axios.defaults.headers.common.Authorization = rawToken
        store.changeNotification({
          text: $gettext('You are now logged in!'),
          autoClose: true,
          type: 'positive',
        })
        resolve(response)
      })
      .catch(error => {
        localStorage.removeItem('user-token')
        localStorage.removeItem('user-refresh')
        delete axios.defaults.headers.common.Authorization
        store.changeNotification({
          text: $gettext('Wrong login or password!'),
          autoClose: true,
          type: 'error',
        })
        reject(error)
      })
  })
}

export function logout () {
  const store = useIndexStore()
  const $gettext = getGettextFunc()
  let promise = null
  if (fakeUser) {
    promise = Promise.resolve()
  } else {
    promise = new Promise((resolve, _reject) => {
      const refreshData = {
        refresh: localStorage.getItem('user-refresh'),
      }
      axios({ url: `${backUrl}token/blacklist`, data: refreshData, method: 'POST' })
        .catch(error => {
          console.log('Something wrong happened when logging out!', error)
        })
        .finally(() => {
          localStorage.removeItem('user-token')
          localStorage.removeItem('user-refresh')
          delete axios.defaults.headers.common.Authorization
          store.changeProjectId(-1)
          store.changeProjectName(null)
          store.changeNotification({
            text: $gettext('You are now logged out!'),
            autoClose: true,
            type: 'positive',
          })
          resolve()
        })
    })
  }
  return promise.then(() => {
    router.push({ name: loginRoute.name })
  })
}

export function refreshToken () {
  if (fakeUser) {
    return Promise.resolve()
  }
  return new Promise((resolve, reject) => {
    const refreshData = {
      refresh: localStorage.getItem('user-refresh'),
    }
    axios({ url: `${backUrl}token/refresh`, data: refreshData, method: 'POST' })
      .then(response => {
        const rawToken = `JWT ${response.data.access}`
        localStorage.setItem('user-token', rawToken)
        axios.defaults.headers.common.Authorization = rawToken
        resolve(response)
      })
      .catch(error => {
        localStorage.removeItem('user-token')
        localStorage.removeItem('user-refresh')
        reject(error)
      })
  })
}
